document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.navSolTabInit').forEach(function (el) {
        el.addEventListener('click', function (e) {
            var target = document.getElementById('soluzioniTabContent');
            if (target) {
                var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 148;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});